import { Component, OnInit, ViewChild, ElementRef, Input, AfterViewInit } from '@angular/core';
import { FirebaseTSApp } from 'firebasets/firebasetsApp/firebaseTSApp';
import { FirebaseTSFirestore, Limit, OrderBy, Where } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { FirebaseTSStorage } from 'firebasets/firebasetsStorage/firebaseTSStorage';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { UserData } from 'src/app/models/user.model';
import { PostData } from 'src/app/models/post.model';
import { AboutBottomSheetComponent } from './about-bottom-sheet/about-bottom-sheet.component';
import { UnfollowConfirmationDialogComponent } from './unfollow-confirmation-dialog/unfollow-confirmation-dialog.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { ImageCropDialogComponent } from 'src/app/image-crop-dialog/image-crop-dialog.component';
import { EditProfileDialogComponent } from 'src/app/edit-profile-dialog/edit-profile-dialog.component';
import { ChangeProfilePictureDialogComponent } from 'src/app/change-profile-picture-dialog/change-profile-picture-dialog.component';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Firestore, doc, updateDoc, arrayUnion, arrayRemove, getFirestore, Timestamp as FirestoreTimestamp, collection, query, where, getDocs, orderBy as fsOrderBy, limit as fsLimit, startAfter, DocumentSnapshot } from 'firebase/firestore';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { EditProfileBottomSheetComponent} from '../edit-profile-bottom-sheet/edit-profile-bottom-sheet.component';
import { ChatContentBottomSheetComponent } from '../chat-content-bottom-sheet/chat-content-bottom-sheet.component';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css'],
})
export class UserProfileComponent implements OnInit, AfterViewInit {
  userId: string;
  userData: UserData;
  userPosts: PostData[] = [];
  @Input() postData: PostData;

  imageChangedEvent: Event | null = null;
  croppedImage: SafeUrl = '';
  
  firestore = new FirebaseTSFirestore();
  followers: string[] = [];
  following: string[] = [];
  followersCount: number = 0;
  followingCount: number = 0;
  profilePhotoUrl: string = '';
  coverPhotoUrl: string = '';
  auth = new FirebaseTSAuth();
  storage = new FirebaseTSStorage();
  private firestore3: Firestore;
  userIdToFollow: string;
  isFollowing: boolean = false;
  currentUserId: string;
  isOwner: boolean;
  currentUser: UserData;
  postsCount: number = 0;
  isLoading: boolean = false;

  @ViewChild('loadMoreTrigger', { static: false }) loadMoreTrigger: ElementRef;

  // Variables pour le continuous scrolling
  private lastDoc: DocumentSnapshot | null = null;
  private batchSize = 5;
  private hasMorePosts = true;
  private isLoadingMore = false;

  constructor(private route: ActivatedRoute, private dialog: MatDialog, private snackBar: MatSnackBar, private bottomSheet: MatBottomSheet, private sanitizer: DomSanitizer, private router: Router) {
    this.firestore3 = getFirestore();  
    console.log('UserProfileComponent initialisé'); 
  }
  
  ngOnInit(): void {
    this.checkIfOwner();
    this.loadUserProfile();
    this.loadCurrentUserProfile();
    this.currentUserId = this.auth.getAuth().currentUser.uid;
    this.userId = this.route.snapshot.paramMap.get('uid');
    console.log("Current user ID:", this.currentUserId);
    console.log("Profile user ID:", this.userId);
  }

  checkIfOwner() {
    this.userIdToFollow = this.route.snapshot.paramMap.get('uid');
    const userId = this.route.snapshot.paramMap.get('uid');
    const currentUserId = this.auth.getAuth().currentUser.uid;
    this.isOwner = userId === currentUserId;
  }

  async loadUserProfile() {
    const userId = this.route.snapshot.paramMap.get('uid'); 
    console.log('loadUserProfile called with userId:', userId);
    
    try {
      const userDoc = await this.firestore.getDocument({
        path: ["Users", userId],
        onComplete: result => {
          console.log('User document loaded:', result.data());
          this.userData = <UserData>result.data();
          
          // Vérifier la visibilité du profil
          if (!this.isOwner && this.userData?.privacySettings?.profileVisibility !== 'public') {
            const canViewProfile = this.checkProfileAccess();
            if (!canViewProfile) {
              this.snackBar.open('Ce profil est privé', 'Fermer', {
                duration: 5000
              });
              this.router.navigate(['/']);
              return;
            }
          }

          if(this.userData?.profilePhotoUrl == ""){
            this.profilePhotoUrl = "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c";
          }else{
            this.profilePhotoUrl = this.userData?.profilePhotoUrl;
          }

          if(this.userData?.coverPhotoUrl == ""){
            this.coverPhotoUrl = "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/defaultCoverImage.jpg?alt=media&token=d509e05d-dd94-4ff3-b37f-24430c3a82bf";
          }else{
            this.coverPhotoUrl = this.userData?.coverPhotoUrl;
          }

          this.followers = this.userData?.followers || [];
          this.following = this.userData?.following || [];
          this.followersCount = this.followers.length;
          this.followingCount = this.following.length;
          this.updateFollowingStatus();
          this.loadUserPosts();
        },
        onFail: err => {
          console.error('Erreur lors du chargement du profil:', err);
          this.snackBar.open('Erreur lors du chargement du profil', 'Fermer', {
            duration: 3000
          });
        }
      });
    } catch (error) {
      console.error('Erreur:', error);
    }
  }

  // Ouvrir le chat dans un bottom sheet (pour mobile)
    openChatBottomSheet(user: UserData): void {
      console.log('Opening chat bottom sheet for user:', user);
      this.bottomSheet.open(ChatContentBottomSheetComponent, {
        data: { user: user },
        panelClass: 'bottom-sheet-container'
      });
    }

   // Méthode pour envoyer un message à l'utilisateur sur mobile
   onMessageUserOnMobile() {
    const userId = this.route.snapshot.paramMap.get('uid'); 
    console.log('onMessageUserOnMobile appelé');
    if (!userId) {
      console.error('ID du créateur non disponible');
      return;
    }

    this.firestore.getDocument({
      path: ["Users", userId],
      onComplete: (result) => {
        if (result.exists) {
          const userData = result.data() as UserData;
          console.log('Données utilisateur récupérées:', userData);
          this.openChatBottomSheet(userData);
        } else {
          console.error('Utilisateur non trouvé');
        }
      },
      onFail: (err) => {
        console.error('Erreur lors de la récupération de l\'utilisateur:', err);
      }
    });
  }

  updateFollowingStatus() {
    if (!this.currentUserId || !this.userData) {
      this.isFollowing = false;
      return;
    }
    this.isFollowing = this.followers.includes(this.currentUserId);
  }

  checkProfileAccess(): boolean {
    if (!this.userData?.privacySettings) return true;

    switch (this.userData.privacySettings.profileVisibility) {
      case 'public':
        return true;
      case 'friends':
        return this.isFriend();
      case 'private':
        return false;
      default:
        return true;
    }
  }

  isFriend(): boolean {
    if (!this.userData || !this.currentUserId) return false;
    return this.userData.followers?.includes(this.currentUserId) && 
           this.userData.following?.includes(this.currentUserId);
  }

  async loadUserPosts() {
    const userId = this.userData?.uid;
    if (!userId) return;

    try {
      this.isLoading = true;

      // Compter le nombre total de posts
      const postsRef = collection(this.firestore3, 'Posts');
      const countQuery = query(postsRef, where('creatorId', '==', userId));
      const querySnapshot = await getDocs(countQuery);
      this.postsCount = querySnapshot.size;

      // Utiliser une requête simple en attendant la création de l'index
      const initialQuery = query(
        postsRef,
        where('creatorId', '==', userId),
        fsLimit(this.batchSize)
      );

      const initialSnapshot = await getDocs(initialQuery);
      this.userPosts = [];
      
      // Convertir les documents en posts et les trier manuellement
      const posts = initialSnapshot.docs.map(doc => {
        const data = doc.data();
        const currentUserId = this.auth.getAuth().currentUser?.uid;
        const isLiked = data.likes?.includes(currentUserId) || false;
        
        return {
          postId: doc.id,
          comment: data.comment || '',
          creatorId: data.creatorId,
          timestamp: data.timestamp,
          likes: data.likes || [],
          comments: data.comments || [],
          shares: data.shares || [],
          type: data.type || '',
          imageUrl: data.imageUrl,
          imageUrls: data.imageUrls,
          videoUrl: data.videoUrl,
          audioUrl: data.audioUrl,
          agribox: data.agribox || false,
          lenali: data.lenali || true,
          linkPreview: data.linkPreview
        } as PostData;
      });

      // Trier les posts par timestamp décroissant
      posts.sort((a, b) => {
        return b.timestamp.seconds - a.timestamp.seconds;
      });

      this.userPosts = posts;
      this.lastDoc = initialSnapshot.docs[initialSnapshot.docs.length - 1] || null;
      this.hasMorePosts = initialSnapshot.docs.length === this.batchSize;
      this.isLoading = false;

      // Afficher le lien pour créer l'index
      console.log('Pour créer l\'index nécessaire, visitez : https://console.firebase.google.com/project/[YOUR_PROJECT_ID]/firestore/indexes');
      console.log('Créez un index composite avec :');
      console.log('Collection: Posts');
      console.log('Champs: creatorId (Ascending) et timestamp (Descending)');
      
    } catch (error) {
      console.error('Erreur lors du chargement des posts:', error);
      this.isLoading = false;
    }
  }

  async loadMorePosts() {
    if (!this.hasMorePosts || this.isLoadingMore || !this.lastDoc) return;

    try {
      this.isLoadingMore = true;
      const userId = this.userData?.uid;
      if (!userId) return;

      const postsRef = collection(this.firestore3, 'Posts');
      // Utiliser une requête simple en attendant la création de l'index
      const nextQuery = query(
        postsRef,
        where('creatorId', '==', userId),
        startAfter(this.lastDoc),
        fsLimit(this.batchSize)
      );

      const nextSnapshot = await getDocs(nextQuery);
      
      // Convertir et trier les nouveaux posts
      const newPosts = nextSnapshot.docs.map(doc => {
        const data = doc.data();
        const currentUserId = this.auth.getAuth().currentUser?.uid;
        const isLiked = data.likes?.includes(currentUserId) || false;
        
        return {
          postId: doc.id,
          comment: data.comment || '',
          creatorId: data.creatorId,
          timestamp: data.timestamp,
          likes: data.likes || [],
          comments: data.comments || [],
          shares: data.shares || [],
          type: data.type || '',
          imageUrl: data.imageUrl,
          imageUrls: data.imageUrls,
          videoUrl: data.videoUrl,
          audioUrl: data.audioUrl,
          agribox: data.agribox || false,
          lenali: data.lenali || true,
          linkPreview: data.linkPreview
        } as PostData;
      });

      // Trier les nouveaux posts
      newPosts.sort((a, b) => {
        return b.timestamp.seconds - a.timestamp.seconds;
      });

      // Ajouter les nouveaux posts triés
      this.userPosts = [...this.userPosts, ...newPosts];
      this.lastDoc = nextSnapshot.docs[nextSnapshot.docs.length - 1] || null;
      this.hasMorePosts = nextSnapshot.docs.length === this.batchSize;
    } catch (error) {
      console.error('Erreur lors du chargement des posts supplémentaires:', error);
    } finally {
      this.isLoadingMore = false;
    }
  }

  loadUserData() {
    this.firestore.getDocument({
      path: ["Users", this.userId],
      onComplete: (result) => {
        const data = result.data();
        this.userData = {
          ...data,
          uid: result.id,
          email: this.auth.getAuth().currentUser?.email || '',
          createdAt: data.createdAt ? new Date(data.createdAt.seconds * 1000) : new Date()
        } as UserData;
        
        this.profilePhotoUrl = this.userData.profilePhotoUrl;
        this.coverPhotoUrl = this.userData.coverPhotoUrl;
        this.loadFollowers();
        this.loadFollowing();
        this.listenToPost();
        // this.loadUserPosts(this.userId);
      }
    });
  }

  loadFollowers() {
    if (!this.userData?.followers) return;
    this.followers = this.userData.followers;
    this.followersCount = this.followers.length;
  }

  loadFollowing() {
    if (!this.userData?.following) return;
    this.following = this.userData.following;
    this.followingCount = this.following.length;
  }

  listenToPost(){
    const userId = this.route.snapshot.paramMap.get('uid'); 
    this.firestore.listenToDocument({
      name: "userFollowersListener",
      path: ["Users", userId],
      onUpdate: (result) => {
        console.log("hahaha");
        const followers = result.data()?.followers ;
        this.isFollowing = followers.includes(this.currentUserId);  
      }
    });
  }

  async toggleLike(postId: string) {
    this.firestore.getDocument({
      path: ["Posts", postId],
      onComplete: async (result) => {
        const postData = <PostData>result.data();
        const likes = postData?.likes || [];

        if (likes.includes(this.currentUserId)) {
          await this.removeLikeFromPost(postId, this.currentUserId);
        } else {
          await this.addLikeToPost(postId, this.currentUserId);
          this.addNotification(postId, "aimé", this.userData.uid, this.currentUserId, this.currentUser.publicName);
        }
      },
      onFail: err => {
        console.error(err);
      }
    });
  }

  onEditProfile(): void {
    const bottomSheetRef = this.bottomSheet.open(EditProfileBottomSheetComponent, {
      data: {
        publicName: this.userData.publicName,
        description: this.userData.description,
        profession: this.userData.profession,
        telephone: this.userData.telephone || '',
        ville: this.userData.ville,
        profilePhotoUrl: this.userData.profilePhotoUrl
      },
      panelClass: 'bottom-sheet-container'
    });

    bottomSheetRef.afterDismissed().subscribe(result => {
      if (result) {
        // Mettre à jour les données utilisateur
        const updates = {
          publicName: result.name,
          profession: result.profession,
          ville: result.city,
          profilePhotoUrl: result.profilePhotoUrl
        };

        this.firestore.update({
          path: ['Users', this.userData.uid],
          data: updates,
          onComplete: () => {
            this.snackBar.open('Profil mis à jour avec succès', 'Fermer', {
              duration: 3000
            });
            // Mettre à jour les données locales
            this.userData = { ...this.userData, ...updates };
          },
          onFail: (err) => {
            console.error('Erreur lors de la mise à jour du profil:', err);
            this.snackBar.open('Erreur lors de la mise à jour du profil', 'Fermer', {
              duration: 3000
            });
          }
        });
      }
    });
  }

  getUserId(): string {
    return this.auth.getAuth().currentUser.uid;;
  }

  async addLikeToPost(postId: string, userId: string): Promise<void> {
    this.loadUserProfile();
    try {
      const postRef = doc(this.firestore3, `Posts/${postId}`);
      await updateDoc(postRef, {
        likes: arrayUnion(userId)  
      });
      console.log('Like ajouté avec succès!');
    } catch (error) {
      console.error('Erreur lors de l\'ajout du like:', error);
    }
  }

  addNotification(postId: string, interactionType: string, recipientUserId: string, senderUserId: string, senderUserName: string) {
    const firestore = new FirebaseTSFirestore();
    const notification = {
      postId: postId,
      interactionType: interactionType,  
      recipientUserId: recipientUserId,  
      senderUserId: senderUserId,        
      senderUserName: senderUserName,
      timestamp: new Date().toISOString(),
      isRead: false
    };
    if(recipientUserId != senderUserId){
      firestore.create({
        path: ["Notifications"],
        data: notification,
        onComplete: () => {
          console.log("Notification added successfully");
        },
        onFail: (err) => {
          console.error("Failed to add notification:", err);
        }
      });
    }
  }

  async removeLikeFromPost(postId: string, userId: string): Promise<void> {
    try {
      const postRef = doc(this.firestore3, `Posts/${postId}`);
      await updateDoc(postRef, {
        likes: arrayRemove(userId)  
      });
      console.log('Like supprimé avec succès!');
    } catch (error) {
      console.error('Erreur lors de la suppression du like:', error);
    }
  }

  openAboutSheet() {
    this.bottomSheet.open(AboutBottomSheetComponent, {
      data: {
        userData: this.userData
      },
      panelClass: 'about-bottom-sheet'
    });
  }

  async onChangeProfilePhoto() {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
  
    fileInput.onchange = async (e: any) => {
      const file = e.target.files[0];
      if (file) {
        try {
          this.isLoading = true;
          const storage = new FirebaseTSStorage();
          const path = `Users/${this.auth.getAuth().currentUser.uid}/cover_photo/${new Date().getTime()}_${file.name}`;
          const uploadResult = await storage.upload({
            uploadName: "profile_photo",
            path: [path],
            data: {
              data: file
            },
            onComplete: async (downloadUrl) => {
              await this.firestore.update({
                path: ["Users", this.auth.getAuth().currentUser.uid],
                data: { profilePhotoUrl: downloadUrl }
              });
              this.profilePhotoUrl = downloadUrl;
              this.snackBar.open('Photo de profil mise à jour avec succès', 'Fermer', {
                duration: 3000
              });
              this.isLoading = false;
            }
          });
        } catch (error) {
          console.error('Erreur lors du changement de photo de profil:', error);
          this.snackBar.open('Erreur lors de la mise à jour de la photo de profil', 'Fermer', {
            duration: 3000
          });
          this.isLoading = false;
        }
      }
    };
    fileInput.click();
  }

  async onChangeCoverPhoto() {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
  
    fileInput.onchange = async (e: any) => {
      const file = e.target.files[0];
      if (file) {
        try {
          this.isLoading = true;
          const storage = new FirebaseTSStorage();
          const path = `Users/${this.auth.getAuth().currentUser.uid}/cover_photo/${new Date().getTime()}_${file.name}`;
          const uploadResult = await storage.upload({
            uploadName: "cover_photo",
            path: [path],
            data: {
              data: file
            },
            onComplete: async (downloadUrl) => {
              await this.firestore.update({
                path: ["Users", this.auth.getAuth().currentUser.uid],
                data: { coverPhotoUrl: downloadUrl }
              });
              this.coverPhotoUrl = downloadUrl;
              this.snackBar.open('Photo de couverture mise à jour avec succès', 'Fermer', {
                duration: 3000
              });
              this.isLoading = false;
            }
          });
        } catch (error) {
          console.error('Erreur lors du changement de photo de couverture:', error);
          this.snackBar.open('Erreur lors de la mise à jour de la photo de couverture', 'Fermer', {
            duration: 3000
          });
          this.isLoading = false;
        }
      }
    };
    fileInput.click();
  }

  async loadCurrentUserProfile() {
    const userId = this.auth.getAuth().currentUser.uid; 
    await this.firestore.getDocument({
      path: ["Users", this.auth.getAuth().currentUser.uid],
      onComplete: result => {
        this.currentUser = <UserData> result.data();
      },
      onFail: err => {
        console.error(err);
      }
    });
  }

  listenToPost3(postId: string): any{
    let commentCount: number = 0;
    this.firestore.listenToCollection(
      {
        name: postId,
        path: ["Posts", postId, "PostComments"],
        where: [new OrderBy("timestamp", "asc")],
        onUpdate: (result)=> {
          commentCount = result.docs.length;
        }
      } 
    );
    return commentCount;
  }

  listenToPost4(postId: string): any{
    let sharesCount : number = 0;
    this.firestore.listenToCollection(
      {
        name: postId,
        path: ["Posts", postId],
        where: [new OrderBy("timestamp", "asc")],
        onUpdate: (result)=> {
          sharesCount = result.docs.length;
        }
      } 
    );
    return sharesCount;
  }

  listenToPost5(postId: string): any{
    let likesCount : number = 0;
    this.firestore.listenToCollection(
      {
        name: postId,
        path: ["Posts", postId],
        where: [new OrderBy("timestamp", "asc")],
        onUpdate: (result)=> {
          likesCount = result.docs.length;
        }
      } 
    );
    return likesCount;
  }

  formatTimestamp(timestamp: FirestoreTimestamp):  any {
    let formattedDate: string = '';  
    if (timestamp) {
      if (timestamp.seconds && timestamp.nanoseconds !== undefined) {
        const postDate = new Date(timestamp.seconds * 1000);
        const currentDate = new Date();
        const timeDifference = currentDate.getTime() - postDate.getTime();
        const oneDayInMs = 86400000; 
        const oneYearInMs = 31536000000; 

        if (timeDifference < oneDayInMs) {
          formattedDate = postDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

        } else if (timeDifference < oneYearInMs) {
          formattedDate = postDate.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit',  }) /*+ ' ' + postDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' }) */;

        } else {
          formattedDate = postDate.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' }) + ' ' + postDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
        }
      } else {
        console.error('Le timestamp ne semble pas être un Firestore Timestamp.');
      }
    }
    return formattedDate;
  }

  toggleFollow() {
    console.log('toggleFollow called'); 

    if (this.isFollowing) {
      const dialogRef = this.dialog.open(UnfollowConfirmationDialogComponent);

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.unfollowUser(this.userIdToFollow, this.currentUserId).then(() => {
            this.isFollowing = false;
          });
        }
      });
    } else {
      this.followUser(this.userIdToFollow, this.currentUserId).then(() => {
        this.isFollowing = true;
      });
    }
  }

  followUser(userIdToFollow: string, currentUserId: string) {
    return this.firestore.update({
      path: ['Users', userIdToFollow],
      data: {
        followers: this.firestore.appendArray(currentUserId) 
      },
      onComplete: () => {
        console.log('Utilisateur suivi avec succès');
        this.addPostCreatorIdToMyFollowing(userIdToFollow, currentUserId);
      },
      onFail: (err) => {
        console.error('Erreur lors du suivi de l\'utilisateur:', err);
      }
    }); 
  }

  addPostCreatorIdToMyFollowing(userIdToFollow: string, currentUserId: string){
    return this.firestore.update({
      path: ['Users', currentUserId],
      data: {
        following: this.firestore.appendArray(userIdToFollow) 
      },
      onComplete: () => {
        console.log('id ajouté à mon following liste avec succès');
      },
      onFail: (err) => {
        console.error('Erreur lors du suivi de l\'utilisateur:', err);
      }
    });
  }

  async unfollowUser(userIdToUnfollow: string, currentUserId: string) {
    try {
      const userToUnFollowRef = doc(this.firestore3, `Users/${userIdToUnfollow}`);
      const myRef = doc(this.firestore3, `Users/${currentUserId}`);

      await updateDoc(myRef, {
        following: arrayRemove(userIdToUnfollow)  
      });

      await updateDoc(userToUnFollowRef, {
        followers: arrayRemove(currentUserId)  
      });

      console.log('Désabonnement effectué avec succès!');
    } catch (error) {
      console.error('Erreur lors de la suppression du like:', error);
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && !this.isLoadingMore && this.hasMorePosts) {
            this.loadMorePosts();
          }
        },
        { threshold: 0.5 }
      );

      if (this.loadMoreTrigger) {
        observer.observe(this.loadMoreTrigger.nativeElement);
      }
    }, 1000); // Petit délai pour s'assurer que le composant est bien initialisé
  }
}
